import isEmpty from 'lodash/isEmpty';
import keys from 'lodash/keys';
import capitalize from 'lodash/capitalize';
import memoize from 'lodash/memoize';

import RedditIcon from 'zignal-landscape/lib/Icon/RedditIcon';
import BlogsIcon from 'zignal-landscape/lib/Icon/BlogsIcon';
import News2Icon from 'zignal-landscape/lib/Icon/News2Icon';
import WeiboIcon from 'zignal-landscape/lib/Icon/WeiboIcon';
import ForumIcon from 'zignal-landscape/lib/Icon/ForumIcon';
import DarkWebIcon from 'zignal-landscape/lib/Icon/DarkWebIcon';
import ReviewIcon from 'zignal-landscape/lib/Icon/ReviewIcon';
import BroadcastIcon from 'zignal-landscape/lib/Icon/BroadcastIcon';
import LexisNexisIcon from 'zignal-landscape/lib/Icon/LexisNexisIcon';
import QaIcon from 'zignal-landscape/lib/Icon/QaIcon';
import VideosIcon from 'zignal-landscape/lib/Icon/VideosIcon';
import VkIcon from 'zignal-landscape/lib/Icon/VkIcon';
import FacebookIcon from 'zignal-landscape/lib/Icon/FacebookIcon';
import InstagramIcon from 'zignal-landscape/lib/Icon/InstagramIcon';
import TwitterIcon from 'zignal-landscape/lib/Icon/TwitterIcon';
import * as PlatformIcon from 'zignal-landscape/lib/PlatformIcon';

import { SUPPORTED_PLATFORMS } from 'zignal-config';
const prodMode = process.env.NODE_ENV === 'production';
// if in prod env, filter out platforms not released to prod
const PLATFORMS = prodMode
  ? SUPPORTED_PLATFORMS.filter(({ prod }) => prod === true)
  : SUPPORTED_PLATFORMS;

const platformDataType = PLATFORMS.reduce((obj, { value, label: verbose }) => {
  obj[value] = { icon: PlatformIcon[`${capitalize(value)}Icon`], verbose };
  return obj;
}, {});

const dataType = {
  'twitter': {
    'icon': TwitterIcon,
    'verbose': 'Twitter'
  },
  'broadcast': {
    'icon': BroadcastIcon,
    'verbose': 'Broadcast'
  },
  'blogs':{
    'count': 0,
    'icon': BlogsIcon,
    'verbose': 'Blogs'
  },
  'lexis_nexis': {
    'icon': LexisNexisIcon,
    'verbose': 'Lexis Nexis'
  },
  'reddit':{
    'icon': RedditIcon,
    'verbose': 'Reddit'
  },
  'news':{
    'icon': News2Icon,
    'verbose': 'News'
  },
  'forum': {
    'icon': ForumIcon,
    'verbose': 'Forum'
  },
  'vk': {
    'icon': VkIcon,
    'verbose': 'VK'
  },
  'weibo': {
    'icon': WeiboIcon,
    'verbose': 'Sina Weibo'
  },
  'review': {
    'icon': ReviewIcon,
    'verbose': 'Review'
  },
  'videos': {
    'icon': VideosIcon,
    'verbose': 'Video'
  },
  'qa': {
    'icon': QaIcon,
    'verbose': 'Q&A'
  },
  'facebook': {
    'icon': FacebookIcon,
    'verbose': 'Facebook'
  },
  'instagram': {
    'icon': InstagramIcon,
    'verbose': 'Instagram'
  },
  'dark_web': {
    'icon': DarkWebIcon,
    'verbose': 'Darkweb+'
  },
  ...platformDataType
};

// the source list shouldn't be changing, so I am using memoize here. Originally the sources were
// assigned to a variable but that was causing issues with x86 architectural race condtion
// for loading Models.Cnadidate
const getAvailableSources = memoize(() => {
  const accountSources = window.Helper.getAccountSources();
  // twitter first, Discover always searches it whatever the account's sources.
  // social_platform is listed as its individual platforms
  return [
    'twitter',
    ...accountSources.filter(source => source !== 'twitter' && source !== 'social_platform'),
    ...(accountSources.includes('social_platform') ? keys(platformDataType) : [])
  ];
});

const getCounts = (data) => {
  const availableSources = getAvailableSources();
  const counts = {};

  data.forEach((value) => {
    // summed per search term, a mention that matches two terms counts twice
    counts.allSources = (counts.allSources || 0) + value.total;
    availableSources.forEach(source => {
      counts[source] = (counts[source] || 0) + (value.sources[source] || 0);
    });
  });

  return counts;
};

const formatValues = (counts) => {
  let formattedData = [];
  if (!isEmpty(counts)) {
    formattedData = [
      {
        value: 'allSources',
        label: `All sources ${counts.allSources.toLocaleString()}`
      }
    ];

    getAvailableSources().forEach((value) => {
      const newSource = {
        value,
        label: `${dataType[value]?.verbose || value} ${counts[value].toLocaleString()}`,
        icon: dataType[value]?.icon
      };
      Object.assign(newSource, counts[value] <= 0 ? {'isDisabled': true} : null);
      formattedData.push(newSource);
    });
  }
  return formattedData;
};

export {
  dataType,
  getCounts,
  formatValues
};
